import { render } from "./FadeTransition.vue?vue&type=template&id=d3966562"
const script = {}
script.render = render

export default script